import defaultTheme from './themedefault';
import clone from 'clone';

const theme = clone(defaultTheme);
theme.palette.primary = ['#F3F3F3'];
theme.palette.secondary = ['#323332'];
export default theme;